import { useEffect } from "react";

const useParallaxEffect = () => {
  useEffect(() => {
    const triangleElements = Array.from(document.querySelectorAll(".triangle"));
    const triangleData = triangleElements.map((triangle) => {
      const rect = triangle.getBoundingClientRect();
      const initialTop = rect.top + window.scrollY;
      const height = rect.height;
      return { element: triangle, initialTop, height };
    });

    const applyParallaxEffect = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;

      const footer = document.querySelector(".footer");
      let footerTop = Infinity;
      let maxScroll = scrollPosition;
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        footerTop = footerRect.top + scrollPosition;
        maxScroll = footerTop - windowHeight;
      }

      const footerFullyInView = scrollPosition + windowHeight >= footerTop;
      // If scrollPosition is 0, force effectiveScroll to 0.
      const effectiveScroll =
        scrollPosition === 0
          ? 0
          : footerFullyInView
          ? maxScroll
          : scrollPosition;

      const speedFactors = [1.5, 2.5, -1, -1.2, 2.8, -1.1];
      const rotationSpeeds = [0.1, -0.2, 0.3, -0.4, 0.2, -0.3];
      const logoSpeedFactor = 0.4;

      // Check if .main-content exists before getting its height.
      const root = document.querySelector(".main-content");
      let rootHeight = 0;
      if (root) {
        rootHeight = root.getBoundingClientRect().height;
        console.log("root height: " + rootHeight);
      }

      triangleElements.forEach((triangle, index) => {
        if (index >= 0 && index <= 5) {
          const speedFactor = speedFactors[index] || 1;
          const rotationSpeed = rotationSpeeds[index] || 0.1;
          const { initialTop, height } = triangleData[index];

          // Compute the translation based on effective scroll.
          const rawTranslateY = effectiveScroll * (speedFactor / 2);
          let translateY = rawTranslateY;

          // For triangles that move downward (positive speedFactor), check if their bottom would go past footer's top.
          if (speedFactor > 0) {
            const newBottom = initialTop + rawTranslateY + height;
            if (newBottom > footerTop) {
              // Clamp the translation so the triangle's bottom equals the footer's top.
              translateY = footerTop - height - initialTop;
            }
          }

          const rotation = effectiveScroll * rotationSpeed + 30;

          // Update opacity and transform based on footer visibility.
          if (scrollPosition > 0 && footerFullyInView) {
            triangle.style.opacity = 0;
            translateY = rootHeight;
          } else {
            triangle.style.opacity = 1;
          }
          triangle.style.transform = `translateY(${translateY}px) rotate(${rotation}deg)`;
        } else if (index === 6 || index === 7) {
          const direction = index === 6 ? -1 : 1;
          const translateX = effectiveScroll * direction * 10;
          if (index === 6) {
            triangle.style.transform = `translateX(${translateX}px)`;
          } else {
            triangle.style.transform = `translateX(${translateX}px) rotate(141deg)`;
          }
        } else if (index === 8) {
          const { initialTop, height } = triangleData[index];
          let translateY = effectiveScroll * -10;
          const newBottom = initialTop + translateY + height;
          if (newBottom > footerTop) {
            translateY = footerTop - height - initialTop;
          }
          triangle.style.transform = `translateY(${translateY}px) rotate(-6deg)`;
        }
      });

      const logo = document.querySelector(".logo");
      if (logo) {
        logo.style.transform = `translate(-50%, calc(-50% + ${
          effectiveScroll * logoSpeedFactor
        }px))`;
      }
    };

    window.addEventListener("scroll", applyParallaxEffect);
    applyParallaxEffect();
    return () => window.removeEventListener("scroll", applyParallaxEffect);
  }, []);
};

export default useParallaxEffect;
